/**
 * @copyright Copyright (c) Mathieu Vanbeselaëre
 */

// ** File summary ** //
// Menu related animations;
// -> including appear/hide and color change to contrast it with the background!

// ************** GSAP animation modules (Uncomment required gsap library!) ************** //
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
// import ScrollSmoother from "gsap/ScrollSmoother"; gsap.registerPlugin(ScrollSmoother);
// import ScrollToPlugin from "gsap/ScrollToPlugin"; gsap.registerPlugin(ScrollToPlugin);
// import DrawSVGPlugin from "gsap/DrawSVGPlugin"; gsap.registerPlugin(DrawSVGPlugin);
// import MorphSVG from "gsap/MorphSVGPlugin"; gsap.registerPlugin(MorphSVG);
// import SplitText from "gsap/SplitText"; gsap.registerPlugin(SplitText);
// *=====================================================================================* //

export const menu = () => {
    let menu = document.querySelector('.menu');
    let mobile = window.innerWidth <= 768;

    if (menu) {

        menu.classList.add('menu-visible');
        let menuVisible = () => menu.classList.contains('menu-visible');

        // * A) Show / hide on scroll
        let lastKnownScrollPosition = 0;
        window.addEventListener('scroll', (e) => {
            if (lastKnownScrollPosition < window.scrollY) {
                if (menuVisible()) {
                    if (document.documentElement.scrollTop > 100) { // Don't hide at the top of the page
                        menu.classList.remove('menu-visible');
                    }
                }
            } else {
                if (!menuVisible()) {
                    menu.classList.add('menu-visible');
                }
            }

            lastKnownScrollPosition = window.scrollY;
        });

        // * B) Show when mouse goes up
        if (!mobile) {
            // Detect when the mouse if moving.
            // If it's above a certain treshold, show the menu.
            // Set a timeout then check again for the client's mouse.
            // If it is now below the treshold, hide the menu, else, keep it and repeat said timeout.
            // Block further detection during the timeout.

            let upperViewportSize = 0.1; // x % of the screen
            let threshold = window.innerHeight * upperViewportSize;
            let lastKnownMousePosition = null;
            let waiting = false;

            // Add custom blockers if we don't want to reveal the menu at specific times
            let checkAllowed = () => {
                let albumContainer = document.querySelector('.album-container');
                if (albumContainer && albumContainer.getAttribute('data-open') == 'true') {
                    return false;
                }

                return true;
            };

            window.addEventListener('mousemove', (e) => {
                if (!menuVisible()) {
                    if (lastKnownMousePosition && e.y < lastKnownMousePosition && e.y < threshold && checkAllowed()) {
                        menu.classList.add('menu-visible');

                        waiting = true;

                        setTimeout(() => {
                            waiting = false;
                        }, 3000);
                    }
                } else if (
                    lastKnownMousePosition &&
                    document.documentElement.scrollTop != 0 && // Don't hide at the top of the page
                    !waiting &&
                    e.y > lastKnownMousePosition &&
                    e.y > threshold
                ) {
                    menu.classList.remove('menu-visible');
                }

                lastKnownMousePosition = e.y;
            });
        }

        // * C) Change the menu contrast according to the current section
        if (!mobile) {
            let sections = document.querySelectorAll('[data-menu]');
            if (sections.length > 0) {
                let menuToggle = (el) => {
                    let toDark = (el.getAttribute('data-menu') == 'black');
                    if (toDark) {
                        menu.classList.add('menu-dark');
                    } else {
                        menu.classList.remove('menu-dark');
                    }
                };

                for (let currentSection of sections) {
                    gsap.set(currentSection, {
                        scrollTrigger: {
                            trigger: currentSection,
                            start: 'top ' + menu.offsetHeight / 2,
                            end: 'bottom ' + menu.offsetHeight / 2,
                            onEnter: () => menuToggle(currentSection),
                            onEnterBack: () => menuToggle(currentSection),
                        },
                    });
                }
            }
        }

        // * D) Scroll into view on click
        let menuLinks = menu.querySelectorAll('.menu-link');
        if (menuLinks.length > 0 && !mobile) {
            for (let menuLink of menuLinks) {
                menuLink.addEventListener('click', (e) => {
                    let link = e.currentTarget.getAttribute('href');
                    if (link.startsWith('#')) {
                        e.preventDefault();
                        setTimeout(() => {
                            menu.classList.remove('menu-visible');
                        }, 2222); // Remove after the scroll because the menu reappears when we go on a upper link.

                        gsap.to(window, {
                            scrollTo: {
                                y: link,
                                autoKill: mobile ? false : true,
                                offsetY: mobile ? menu.offsetHeight + 25 : 25,
                            },
                            duration: 2,
                            ease: 'power1.inOut',
                        });
                    }
                });
            }
        }
    }

    return;
};
